












































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog, Toast } from 'vant';
@Component
export default class PlatformBind extends Vue {
  show: boolean = true;
  count: number = 0;
  timer: any = null;
  formData: Partial<any> = {
    UserName: '',
    Password: '',
    Captcha: '',
    Phone: '',
    WxOpenId: '',
  };

  async getCode() {
    if (this.formData.Phone.length < 1) {
      Dialog.alert({
        title: '提示',
        message: '请输入手机号。',
      });
      return;
    }
    const result = await api.AccountApp.sendSms_POST({
      Phone: this.formData.Phone,
    });

    if (result.success) {
      const TIME_COUNT = 30;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    } else {
      Toast(result.message);
    }
  }

  async onSubmit() {
    const toast = Toast.loading({
      duration: 0,
      forbidClick: true,
      message: '绑定中...',
    });
    try {
      const data = await api.AccountApp.platformBind_POST(this.formData);
      if (data.success) {
        Dialog.alert({
          title: '提示',
          message: data.message ? data.message : '绑定成功',
        });
        toast.clear();
        this.$router.push('/home');
      } else {
        toast.clear();
        Dialog.alert({
          title: '提示',
          message: data.message ? data.message : '绑定失败',
        });
      }
    } catch (error) {
      Toast.fail(error);
    }
  }

  mounted() {
    this.formData.WxOpenId = this.$route.query.openId;
  }
}
